import { makeTAddIsNotMoralOrIgnored } from '../../TYPE/logic';
export var makeShowLogic = function (parentNameAdditionalPaths) { return makeTAddIsNotMoralOrIgnored({
    parentNameAdditionalPaths: parentNameAdditionalPaths,
}); };
export var showLogic = makeShowLogic();
